import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import SwipeableTemporaryDrawer from './SwipeableTemporaryDrawer';
import ClientProvider from './client';
export default createDemo(import.meta.url, SwipeableTemporaryDrawer, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/drawers/demos/swipeable-temporary/SwipeableTemporaryDrawer.tsx",
    "fileName": "SwipeableTemporaryDrawer.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport SwipeableDrawer from '@mui/material/SwipeableDrawer';\nimport Button from '@mui/material/Button';\nimport List from '@mui/material/List';\nimport Divider from '@mui/material/Divider';\nimport ListItem from '@mui/material/ListItem';\nimport ListItemButton from '@mui/material/ListItemButton';\nimport ListItemIcon from '@mui/material/ListItemIcon';\nimport ListItemText from '@mui/material/ListItemText';\nimport InboxIcon from '@mui/icons-material/MoveToInbox';\nimport MailIcon from '@mui/icons-material/Mail';\n\ntype Anchor = 'top' | 'left' | 'bottom' | 'right';\n\nexport default function SwipeableTemporaryDrawer() {\n  const [state, setState] = React.useState({\n    top: false,\n    left: false,\n    bottom: false,\n    right: false,\n  });\n\n  const toggleDrawer =\n    (anchor: Anchor, open: boolean) =>\n    (event: React.KeyboardEvent | React.MouseEvent) => {\n      if (\n        event &&\n        event.type === 'keydown' &&\n        ((event as React.KeyboardEvent).key === 'Tab' ||\n          (event as React.KeyboardEvent).key === 'Shift')\n      ) {\n        return;\n      }\n\n      setState({ ...state, [anchor]: open });\n    };\n\n  const list = (anchor: Anchor) => (\n    <Box\n      sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}\n      role=\"presentation\"\n      onClick={toggleDrawer(anchor, false)}\n      onKeyDown={toggleDrawer(anchor, false)}\n    >\n      <List>\n        {['Inbox', 'Starred', 'Send email', 'Drafts'].map((text, index) => (\n          <ListItem key={text} disablePadding>\n            <ListItemButton>\n              <ListItemIcon>\n                {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}\n              </ListItemIcon>\n              <ListItemText primary={text} />\n            </ListItemButton>\n          </ListItem>\n        ))}\n      </List>\n      <Divider />\n      <List>\n        {['All mail', 'Trash', 'Spam'].map((text, index) => (\n          <ListItem key={text} disablePadding>\n            <ListItemButton>\n              <ListItemIcon>\n                {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}\n              </ListItemIcon>\n              <ListItemText primary={text} />\n            </ListItemButton>\n          </ListItem>\n        ))}\n      </List>\n    </Box>\n  );\n\n  return (\n    <div>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      {(['left', 'right', 'top', 'bottom'] as const).map((anchor) => (\n        <React.Fragment key={anchor}>\n          <Button onClick={toggleDrawer(anchor, true)}>{anchor}</Button>\n          <SwipeableDrawer\n            anchor={anchor}\n            open={state[anchor]}\n            onClose={toggleDrawer(anchor, false)}\n            onOpen={toggleDrawer(anchor, true)}\n          >\n            {list(anchor)}\n          </SwipeableDrawer>\n        </React.Fragment>\n      ))}\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </div>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 91,
        "focusedLines": 13,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport SwipeableDrawer from '@mui/material/SwipeableDrawer';\nimport Button from '@mui/material/Button';\nimport List from '@mui/material/List';\nimport Divider from '@mui/material/Divider';\nimport ListItem from '@mui/material/ListItem';\nimport ListItemButton from '@mui/material/ListItemButton';\nimport ListItemIcon from '@mui/material/ListItemIcon';\nimport ListItemText from '@mui/material/ListItemText';\nimport InboxIcon from '@mui/icons-material/MoveToInbox';\nimport MailIcon from '@mui/icons-material/Mail';\n\ntype Anchor = 'top' | 'left' | 'bottom' | 'right';\n\nexport default function SwipeableTemporaryDrawer() {\n  const [state, setState] = React.useState({\n    top: false,\n    left: false,\n    bottom: false,\n    right: false,\n  });\n\n  const toggleDrawer =\n    (anchor: Anchor, open: boolean) =>\n    (event: React.KeyboardEvent | React.MouseEvent) => {\n      if (\n        event &&\n        event.type === 'keydown' &&\n        ((event as React.KeyboardEvent).key === 'Tab' ||\n          (event as React.KeyboardEvent).key === 'Shift')\n      ) {\n        return;\n      }\n\n      setState({ ...state, [anchor]: open });\n    };\n\n  const list = (anchor: Anchor) => (\n    <Box\n      sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}\n      role=\"presentation\"\n      onClick={toggleDrawer(anchor, false)}\n      onKeyDown={toggleDrawer(anchor, false)}\n    >\n      <List>\n        {['Inbox', 'Starred', 'Send email', 'Drafts'].map((text, index) => (\n          <ListItem key={text} disablePadding>\n            <ListItemButton>\n              <ListItemIcon>\n                {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}\n              </ListItemIcon>\n              <ListItemText primary={text} />\n            </ListItemButton>\n          </ListItem>\n        ))}\n      </List>\n      <Divider />\n      <List>\n        {['All mail', 'Trash', 'Spam'].map((text, index) => (\n          <ListItem key={text} disablePadding>\n            <ListItemButton>\n              <ListItemIcon>\n                {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}\n              </ListItemIcon>\n              <ListItemText primary={text} />\n            </ListItemButton>\n          </ListItem>\n        ))}\n      </List>\n    </Box>\n  );\n\n  return (\n    <div>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      {(['left', 'right', 'top', 'bottom'] as const).map((anchor) => (\n        <React.Fragment key={anchor}>\n          <Button onClick={toggleDrawer(anchor, true)}>{anchor}</Button>\n          <SwipeableDrawer\n            anchor={anchor}\n            open={state[anchor]}\n            onClose={toggleDrawer(anchor, false)}\n            onOpen={toggleDrawer(anchor, true)}\n          >\n            {list(anchor)}\n          </SwipeableDrawer>\n        </React.Fragment>\n      ))}\n"
      ],
      [
        "span",
        "frame",
        "    </div>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 76
            },
            [
              "      ",
              [
                "span",
                "pl-pse",
                "{"
              ],
              "([",
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ],
                  "left",
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ]
                ]
              ],
              ", ",
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ],
                  "right",
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ]
                ]
              ],
              ", ",
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ],
                  "top",
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ]
                ]
              ],
              ", ",
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ],
                  "bottom",
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ]
                ]
              ],
              "] ",
              [
                "span",
                "pl-k",
                "as"
              ],
              " ",
              [
                "span",
                "pl-k",
                "const"
              ],
              ").",
              [
                "span",
                "pl-en",
                "map"
              ],
              "((",
              [
                "span",
                "pl-v",
                "anchor"
              ],
              ") ",
              [
                "span",
                "pl-k di-pu",
                "=>"
              ],
              " ("
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 77
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "React.Fragment"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "key"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "anchor"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 78
            },
            [
              "          <",
              [
                "span",
                "pl-c1 di-jsx",
                "Button"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "onClick"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-en",
                "toggleDrawer"
              ],
              "(",
              [
                "span",
                "pl-smi di-jv",
                "anchor"
              ],
              ", ",
              [
                "span",
                "pl-c1 di-bool",
                "true"
              ],
              ")",
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi",
                "anchor"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              "</",
              [
                "span",
                "pl-c1 di-jsx",
                "Button"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 79
            },
            [
              "          <",
              [
                "span",
                "pl-c1 di-jsx",
                "SwipeableDrawer"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 80
            },
            [
              "            ",
              [
                "span",
                "pl-e di-ak",
                "anchor"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "anchor"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 81
            },
            [
              "            ",
              [
                "span",
                "pl-e di-ak",
                "open"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "state"
              ],
              "[",
              [
                "span",
                "pl-smi di-jv",
                "anchor"
              ],
              "]",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 82
            },
            [
              "            ",
              [
                "span",
                "pl-e di-ak",
                "onClose"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-en",
                "toggleDrawer"
              ],
              "(",
              [
                "span",
                "pl-smi di-jv",
                "anchor"
              ],
              ", ",
              [
                "span",
                "pl-c1 di-bool",
                "false"
              ],
              ")",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 83
            },
            [
              "            ",
              [
                "span",
                "pl-e di-ak",
                "onOpen"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-en",
                "toggleDrawer"
              ],
              "(",
              [
                "span",
                "pl-smi di-jv",
                "anchor"
              ],
              ", ",
              [
                "span",
                "pl-c1 di-bool",
                "true"
              ],
              ")",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 84
            },
            "          >"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 85
            },
            [
              "            ",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-en",
                "list"
              ],
              "(",
              [
                "span",
                "pl-smi",
                "anchor"
              ],
              ")",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 86
            },
            [
              "          </",
              [
                "span",
                "pl-c1 di-jsx",
                "SwipeableDrawer"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 87
            },
            [
              "        </",
              [
                "span",
                "pl-c1 di-jsx",
                "React.Fragment"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 88
            },
            [
              "      ))",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 91,
    "focusedLines": 13,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Box",
      "@mui/material/SwipeableDrawer",
      "@mui/material/Button",
      "@mui/material/List",
      "@mui/material/Divider",
      "@mui/material/ListItem",
      "@mui/material/ListItemButton",
      "@mui/material/ListItemIcon",
      "@mui/material/ListItemText",
      "@mui/icons-material/MoveToInbox",
      "@mui/icons-material/Mail"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
